// Libs

import { v4 as uuidv4 } from 'uuid';

// Constants
import { USER_SERVICE, SERVICE_VERSION_1, roles, tenants, countryCodes } from '../configurations/settings';

// Interfaces

var preparePayloadData = function preparePayloadData(msCompanyData, payload) {
  var _msCompanyData$compAt, _msCompanyData$compAt2, _msCompanyData$compAt3, _msCompanyData$billin, _msCompanyData$compAt4, _msCompanyData$billin2, _msCompanyData$billin3, _msCompanyData$billin4, _msCompanyData$billin5, _msCompanyData$billin6;
  var dcsObj = {};
  var billingAddressObj = {};
  var registeredAddressObj = {};
  dcsObj.name = msCompanyData.companyName;
  dcsObj.country = msCompanyData.countryCode;
  dcsObj.invoiceEmail = msCompanyData.userEmailId;
  dcsObj.addresses = [];
  switch (msCompanyData === null || msCompanyData === void 0 ? void 0 : msCompanyData.countryCode) {
    case countryCodes.GERMANY:
      dcsObj.taxId = String((_msCompanyData$compAt = msCompanyData.compAttributes) === null || _msCompanyData$compAt === void 0 || (_msCompanyData$compAt = _msCompanyData$compAt.find(function (item) {
        return item.attributeName === 'VAT';
      })) === null || _msCompanyData$compAt === void 0 ? void 0 : _msCompanyData$compAt.value);
      dcsObj.preferableLanguage = 'de';
      break;
    case countryCodes.DENMARK:
    case countryCodes.SWEDEN:
    case countryCodes.LUXEMBOURG:
    case countryCodes.NETHERLANDS:
      dcsObj.taxId = String((_msCompanyData$compAt2 = msCompanyData.compAttributes) === null || _msCompanyData$compAt2 === void 0 || (_msCompanyData$compAt2 = _msCompanyData$compAt2.find(function (item) {
        return item.attributeName === 'VAT';
      })) === null || _msCompanyData$compAt2 === void 0 ? void 0 : _msCompanyData$compAt2.value);
      dcsObj.preferableLanguage = 'en';
      break;
    case countryCodes.INDIA:
      dcsObj.taxId = String((_msCompanyData$compAt3 = msCompanyData.compAttributes) === null || _msCompanyData$compAt3 === void 0 || (_msCompanyData$compAt3 = _msCompanyData$compAt3.find(function (item) {
        return item.attributeName === 'GST';
      })) === null || _msCompanyData$compAt3 === void 0 ? void 0 : _msCompanyData$compAt3.value);
      dcsObj.preferableLanguage = 'en';
      billingAddressObj.state = (_msCompanyData$billin = msCompanyData.billingAddress) === null || _msCompanyData$billin === void 0 ? void 0 : _msCompanyData$billin.stateIsoCode;
      break;
    case countryCodes.UNITED_STATES:
      dcsObj.taxId = String((_msCompanyData$compAt4 = msCompanyData.compAttributes) === null || _msCompanyData$compAt4 === void 0 || (_msCompanyData$compAt4 = _msCompanyData$compAt4.find(function (item) {
        return item.attributeName === 'TIN';
      })) === null || _msCompanyData$compAt4 === void 0 ? void 0 : _msCompanyData$compAt4.value);
      dcsObj.preferableLanguage = 'en';
      billingAddressObj.state = (_msCompanyData$billin2 = msCompanyData.billingAddress) === null || _msCompanyData$billin2 === void 0 ? void 0 : _msCompanyData$billin2.stateIsoCode;
      break;
  }
  billingAddressObj.postalCode = (_msCompanyData$billin3 = msCompanyData.billingAddress) === null || _msCompanyData$billin3 === void 0 ? void 0 : _msCompanyData$billin3.postalCode;
  billingAddressObj.city = (_msCompanyData$billin4 = msCompanyData.billingAddress) === null || _msCompanyData$billin4 === void 0 ? void 0 : _msCompanyData$billin4.cityName;
  billingAddressObj.houseNumber = (_msCompanyData$billin5 = msCompanyData.billingAddress) === null || _msCompanyData$billin5 === void 0 ? void 0 : _msCompanyData$billin5.addressLine1;
  billingAddressObj.street = (_msCompanyData$billin6 = msCompanyData.billingAddress) === null || _msCompanyData$billin6 === void 0 ? void 0 : _msCompanyData$billin6.addressLine2;
  billingAddressObj.country = msCompanyData === null || msCompanyData === void 0 ? void 0 : msCompanyData.countryCode;
  billingAddressObj.addressTypes = ['BILLING'];
  if (msCompanyData.shippingAddressSameAsBilling) {
    billingAddressObj.addressTypes = ['BILLING', 'REGISTERED'];
    dcsObj.addresses.push(billingAddressObj);
  } else {
    var _msCompanyData$shippi, _msCompanyData$shippi2, _msCompanyData$shippi3, _msCompanyData$shippi4, _msCompanyData$shippi5, _msCompanyData$shippi6;
    registeredAddressObj.postalCode = (_msCompanyData$shippi = msCompanyData.shippingAddress) === null || _msCompanyData$shippi === void 0 ? void 0 : _msCompanyData$shippi.postalCode;
    registeredAddressObj.city = (_msCompanyData$shippi2 = msCompanyData.shippingAddress) === null || _msCompanyData$shippi2 === void 0 ? void 0 : _msCompanyData$shippi2.cityName;
    registeredAddressObj.street = (_msCompanyData$shippi3 = msCompanyData.shippingAddress) === null || _msCompanyData$shippi3 === void 0 ? void 0 : _msCompanyData$shippi3.addressLine2;
    registeredAddressObj.houseNumber = (_msCompanyData$shippi4 = msCompanyData.shippingAddress) === null || _msCompanyData$shippi4 === void 0 ? void 0 : _msCompanyData$shippi4.addressLine1;
    registeredAddressObj.country = (_msCompanyData$shippi5 = msCompanyData.shippingAddress) === null || _msCompanyData$shippi5 === void 0 ? void 0 : _msCompanyData$shippi5.countryCode;
    registeredAddressObj.state = (_msCompanyData$shippi6 = msCompanyData.shippingAddress) === null || _msCompanyData$shippi6 === void 0 ? void 0 : _msCompanyData$shippi6.stateIsoCode;
    registeredAddressObj.addressTypes = ['REGISTERED'];
    dcsObj.addresses.push(billingAddressObj);
    dcsObj.addresses.push(registeredAddressObj);
  }
  if (payload.dcsJWTToken) {
    dcsObj.userInfo = {};
    dcsObj.userInfo.firstName = msCompanyData.userFirstName;
    dcsObj.userInfo.lastName = msCompanyData.userLastName;
    dcsObj.userInfo.email = msCompanyData.userEmailId;
    dcsObj.userInfo.preferableLanguage = msCompanyData.countryCode === countryCodes.GERMANY ? 'de' : 'en';
    dcsObj.msCompanyId = msCompanyData.companyId;
  }
  return dcsObj;
};
export var createDCSCompany = function createDCSCompany(msCompanyData, payload) {
  var requestPayload = preparePayloadData(msCompanyData, payload);
  var headers = {
    'Authorization': 'bearer ' + payload.clientToken,
    'Idempotency-Key': uuidv4()
  };
  if (payload.requestorPayload) {
    headers['requestor'] = payload.requestorPayload;
  }
  if (payload.dcsJWTToken) {
    headers['dcs-token'] = payload.dcsJWTToken;
  }
  if (payload.role === roles.SELLER_ROLE) {
    headers['x-tenant'] = tenants.MKOS;
  } else if (payload.tenantId === tenants.MOS_IND) {
    headers['x-tenant'] = payload.tenantId;
  }
  return payload.axiosInstance.post("/".concat(USER_SERVICE, "/").concat(SERVICE_VERSION_1) + "/user/company/".concat(msCompanyData === null || msCompanyData === void 0 ? void 0 : msCompanyData.companyId, "/register"), requestPayload, {
    headers: headers,
    params: {
      role: payload.role
    }
  });
};